import styled from 'styled-components';

import { ContentWrapper } from '@/styles/GlobalStyle';

export const StyledContentWrapper = styled(ContentWrapper)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
